// src/mockData/promises.ts

// Helper to create promise
const createPromise = (
  id: string,
  customerId: string,
  assignedTo: string,
  amount: number,
  dueDate: string,
  status: 'due-today' | 'broken' | 'kept'
) => ({
  id,
  customerId,
  assignedTo,
  amount,
  dueDate,
  status,
  madeDate: '2025-12-15',
  daysBroken: status === 'broken' ? Math.floor(Math.random() * 15) + 1 : 0
});

// Sarah's promises (0 due today, 11 broken)
const sarahPromises = [
  createPromise('PRM-001', 'ACC-001', 'user-001', 15000, '2025-12-28', 'broken'),
  createPromise('PRM-002', 'ACC-002', 'user-001', 22000, '2025-12-30', 'broken'),
  createPromise('PRM-003', 'ACC-003', 'user-001', 18500, '2025-12-29', 'broken'),
  createPromise('PRM-004', 'ACC-001', 'user-001', 12000, '2026-01-02', 'broken'),
  createPromise('PRM-005', 'ACC-002', 'user-001', 16500, '2026-01-03', 'broken'),
  createPromise('PRM-006', 'ACC-003', 'user-001', 14000, '2026-01-04', 'broken'),
  createPromise('PRM-007', 'ACC-004', 'user-001', 9800, '2026-01-05', 'broken'),
  createPromise('PRM-008', 'ACC-001', 'user-001', 11200, '2026-01-06', 'broken'),
  createPromise('PRM-009', 'ACC-002', 'user-001', 13500, '2026-01-07', 'broken'),
  createPromise('PRM-010', 'ACC-003', 'user-001', 10800, '2026-01-08', 'broken'),
  createPromise('PRM-011', 'ACC-004', 'user-001', 8900, '2026-01-08', 'broken')
];

// Mike Chen's promises (0 due today, 3 broken)
const mikePromises = [
  createPromise('PRM-012', 'ACC-006', 'user-002', 25000, '2026-01-05', 'broken'),
  createPromise('PRM-013', 'ACC-007', 'user-002', 18000, '2026-01-06', 'broken'),
  createPromise('PRM-014', 'ACC-008', 'user-002', 21000, '2026-01-07', 'broken')
];

// Emily Rodriguez's promises (0 due today, 4 broken)
const emilyPromises = [
  createPromise('PRM-015', 'ACC-011', 'user-003', 28000, '2026-01-04', 'broken'),
  createPromise('PRM-016', 'ACC-012', 'user-003', 32000, '2026-01-05', 'broken'),
  createPromise('PRM-017', 'ACC-013', 'user-003', 24000, '2026-01-06', 'broken'),
  createPromise('PRM-018', 'ACC-014', 'user-003', 19000, '2026-01-07', 'broken')
];

// David Kim's promises (0 due today, 3 broken)
const davidPromises = [
  createPromise('PRM-019', 'ACC-016', 'user-004', 35000, '2026-01-05', 'broken'),
  createPromise('PRM-020', 'ACC-017', 'user-004', 27000, '2026-01-06', 'broken'),
  createPromise('PRM-021', 'ACC-018', 'user-004', 22000, '2026-01-07', 'broken')
];

// Lisa Anderson's promises (0 due today, 3 broken)
const lisaPromises = [
  createPromise('PRM-022', 'ACC-021', 'user-005', 42000, '2026-01-05', 'broken'),
  createPromise('PRM-023', 'ACC-022', 'user-005', 34000, '2026-01-06', 'broken'),
  createPromise('PRM-024', 'ACC-023', 'user-005', 28000, '2026-01-07', 'broken')
];

// James Wilson's promises (0 due today, 3 broken)
const jamesPromises = [
  createPromise('PRM-025', 'ACC-026', 'user-006', 48000, '2026-01-05', 'broken'),
  createPromise('PRM-026', 'ACC-027', 'user-006', 38000, '2026-01-06', 'broken'),
  createPromise('PRM-027', 'ACC-028', 'user-006', 31000, '2026-01-07', 'broken')
];

export const PROMISES = [
  ...sarahPromises,
  ...mikePromises,
  ...emilyPromises,
  ...davidPromises,
  ...lisaPromises,
  ...jamesPromises
];
